<template>
    <div class="has-text-white top5 scrollableY ">
       <div class="helpHeader"> &nbsp;&nbsp;&nbsp;<img v-show="!inHelp" src="@/assets/img/fourDotsLogo.png" width="20"/>
        
            <span class="handCursor helpTitleDrop" @click="toggleMenu($event)">
                <b> HELP</b>  <span class="is-inline subLabelDownArrow"> <i  class="fa fa-sort-down fa-2x"></i></span>
            </span>
           <div v-show="showMenu" class="helpTree">
                <helpTree class="is-size-6"
                    :item= tree[0] 
                    :depth=0
                    :inHelp=1
                    >
                </helpTree>
           </div>
    
        </div>
        <div class="top20  cmsInAccWidther settsPad">
            <div  v-for="(item, i) in source" :key="i">
                <component :is="item.comp" :params="item.params" :index="i" :isDragged="item.isDragged"></component>
            </div>
            
        </div>
        <!-- <footerdiv></footerdiv> -->

       
    </div>
</template>

<script>

import titleSection from '../components/cms/titleSection.vue'
import subTitleSection from '../components/cms/subTitleSection.vue'
import bundleComplete from '../components/cms/bundleComplete.vue'
import threeColumns from '../components/cms/threeColumns.vue'
import fourColumns from '../components/cms/fourColumns.vue'
import paragraph from '../components/cms/paragraph.vue'
import cmsFooter from '../components/cms/cmsFooter.vue'
import landingHeader from '../components/cms/landingHeader.vue'
import threeAds from '../components/cms/threeAds.vue'
import imageAndText from '../components/cms/imageAndText.vue'
import helpTree from '../components/helpTree.vue'
import divider1 from '../components/cms/divider1.vue'
import dropper from '../components/cms/sectionDropper.vue'
import Footerdiv from '../components/Footer.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
    name: 'settshelp',
    components: {titleSection, dropper, subTitleSection, threeColumns, paragraph, imageAndText, divider1, fourColumns, threeAds, landingHeader, bundleComplete, cmsFooter, Footerdiv, helpTree},
    props: {
        id: {
            type: Number,
            default: null
        },
        inHelp: {
            type: Boolean,
            default: false
        }
       
    },
    data: function(){
        return {
          source: [],
          inited: false,
          tree: [],
          showMenu: false
        }
    },

    beforeDestroy: function(){

        AZEventBus.$off('closeAllMenus', msg => {
            this.showMenu = false
        });

    },

    mounted: function(){
       
        var self = this;
        function init(){
            self.selectPage(self.id)
            self.getPages()
        }

        if(self.$root.app.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });

        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler);
            
       
    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {

        closeAllMenusHandler: function(msg){
            this.showMenu = false
        },


        selectPage: function(id, name, isLanding){
            

            if(!id ){
                id = process.env.VUE_APP_ROOT_HELP
            }
           
           var self = this
           function w(d){


               if(!d.isLanding || d == 'notFound') 
                self.$router.push('/p404')

               self.source = []
               self.$nextTick(function () {
                   self.source = JSON.parse(d.source)
                  /*  self.isLive = d.isLive 
                   self.currentId = id
                   self.currName = name
                   self.isLanding = isLanding */
               })
              
           }

           function n(){

           }

           this.$root.app.apiClient.get('open/confirm/onepage/' + id, {}, w, n)
       },

       getPages: function(){

        var self = this;

        function w(d){

            d.pages.forEach(e => {
                if(e.children)
                    e.children = e.children.split(',')
                else
                    e.children = []
                
            })
            self.buildTree(d.pages)

        }

        function n(){

        }

        this.$root.app.apiClient.get('/open/confirm/pagesheaders', {}, w, n)


       },

       toggleMenu: function(e){
        e.stopPropagation()
        e.preventDefault()

        this.showMenu = !this.showMenu
       },

       buildTree: function(o){
            


            var self = this;
            self.tree = []
            var arr= []

         
            function getChildren(ids){
                var ret = []
                
                for(var i=0; i < ids.length; i++){

                    //if id is not in bundles array, continue
                    
                        ret.push(o.find(function(e){
                            
                            if(parseInt(e.id) == parseInt(ids[i])){
                              
                                e.processed = true
                                
                                if(e.children.length){
                                    e.children = getChildren(e.children)
                                }
                               
                                return true
                            }                           
                        })
                    )
                    
                }
               
                return ret
            }

           

            o.forEach(e => {
                
                if(!e.processed){
                   e.children = getChildren(e.children)
                   arr.push(e)
                }
            })
            

            self.tree = arr

        }
    }
}



</script>